import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class HhsgSharedFormStateService {
	public isFormDirty: boolean = false;
	public continueFunc: Function | null = null;
	public continueArgs: IArguments | null = null;
	private _continueRoute: ActivatedRouteSnapshot | null = null;

	private discardHeldRoutesValue: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public discardHeldRoutes$: Observable<boolean> = this.discardHeldRoutesValue.asObservable();

	private clearAKAEvent = new Subject<void>();
	clearAKAEvent$ = this.clearAKAEvent.asObservable();

	constructor() { }

	public set continueRoute(nextRoute: ActivatedRouteSnapshot | null) {
		this._continueRoute = nextRoute;
		if(nextRoute){
			this.continueArgs = null;
			this.continueFunc = null;
		}
	}

	public get continueRoute():ActivatedRouteSnapshot | null{
		return this._continueRoute;
	}

	public get isNextActionFunction(): boolean {
		return this.continueFunc !== undefined && this.continueArgs !== undefined &&
		this.continueFunc !== null && this.continueArgs !== null;
	}

	public get isNextActionNavigation(): boolean {
		return this.continueRoute !== undefined && this.continueRoute !== null;
	}

	public setDiscardHeldRoutesValue() {
		this.discardHeldRoutesValue.next(true);
	}
	
	public reset(): void{
		this.isFormDirty = false;
		this.continueFunc = null;
		this.continueArgs = null;
		this.continueRoute = null;
	}

	public emitClearAKAEvent(): void {
		this.clearAKAEvent.next();
	}
}
